import { handleResponse } from '@surveycake/utils';
import { domain } from 'config/system';
import { stringify } from 'qs';

const getCredentials = (url: string) =>
  url.startsWith(domain.file) ||
  url.startsWith(domain.assets) ||
  url.startsWith(domain.shorten)
    ? 'omit'
    : 'include';

const createHttpMethod = (method: 'GET' | 'POST' | 'DELETE' | 'HEAD') => (
  url: string,
  options?: RequestInit
) =>
  fetch(url, {
    ...options,
    method,
    credentials: getCredentials(url)
  });

const createGerUrl = (key: keyof typeof domain) => (url: string) =>
  `${domain[key]}${url}`;

export const http = {
  handleResponse,
  /**
   * Resolve the url prefix.
   */
  url: {
    api: (url: string, version: number) => `${domain.api}/v${version}${url}`,
    assets: createGerUrl('assets'),
    file: createGerUrl('file'),
    shorten: createGerUrl('shorten')
  },
  /**
   * Resolve object to query string.
   */
  query: stringify,
  get: createHttpMethod('GET'),
  post: createHttpMethod('POST'),
  delete: createHttpMethod('DELETE'),
  head: createHttpMethod('HEAD')
};
